module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon10.e6266fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon10.png
// module id = QEnZ
// module chunks = 0